import { makeStyles } from '@mui/styles';
import Popup from "reactjs-popup";
import styled from "styled-components";
import Select from '@mui/material/Select';

export const useStyles = makeStyles({

    select: {
      borderRadius: 4,
      position: 'relative',
      border: '1px solid #D3D3D3',
      width: '220px',
      fontFamily:'Open Sans',
    },
  
    title: {
      fontSize: '16px',
      marginLeft: '2%',
      marginBottom:'0%',
      marginTop:'0%',
      fontFamily:'Raleway'
    },
  
    titleInput: {
      marginTop: '13%',
      marginBottom: '2%',
      fontSize:'13px',
      fontFamily:'Open Sans',
      marginLeft: '6px'
    },
    buttons: {
      marginTop: '4%',
    },
  
    table: {
      border: '1px solid #ced4da',
    },
  
    thead: {
      textAlign:'center',
      fontSize: '1em'
    },
    tableCell: {
      fontSize: '16px',
      fontFamily: 'Open Sans',
      marginTop: '50%',
      padding: '6px 0px'
    },
  
    errorIcon: {
      color: '#000'
    },
  
    
    required: {
      color: 'red'
    },
    modal: {
      maxWidth: '510px',
      width:'80%',
      height: '100%',
      marginLeft: '3%',
      maxHeight: '337px',
      ['@media (min-width:570px)']: { 
        overflow:'hidden'
      }
    
    },
    divider: {
      color:'#000',
      opacity: '0.3',
      marginBottom: '-10px'
    },

    control: {
      height: '75px',
      ['@media (max-height:570px)']: { 
        height: '50px'
      }
    },
  
    svg: (props:any) => ({
      fill: '#999999',
      '&:hover': {
        fill: props.color
      },
      float: 'right'
    }),
    loadContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '45vh',
      maxWidth: '220px',
      margin: 'auto'
    },

    loadCotization: {
      display: 'flex',
      height: '8vh',
      maxWidth: '100px',
      marginLeft: '20%',
      marginTop: '-3%',
      marginBottom: '10%',
      ['@media (min-width:770px)']: { 
        display: 'flex',
        height: '8vh',
        maxWidth: '100px',
        marginLeft: '45%',
        marginTop: '-3%',
        marginBottom: '10%',
      }
      
    },
    warning: {
      color: '#000 !important',
    },

    warningInfo:{
      border: '2px solid #F5E414'
    },

    textAlert:{
      marginTop: '2%'
    },

    warningContent:{
      ['@media (max-width:280px)']: { 
        width: '286px',
        marginLeft: '2.5%', 
        border: '2px solid #F5E414'
      },

      ['@media (max-width:1024px)']: { 
        width: '100%',
        marginLeft: '3.5%', 
        border: '2px solid #F5E414'
      },
      
      maxWidth: '74%',
      marginLeft: '1%', 
      border: '2px solid #F5E414',

      ['@media (max-width:768px)']: { 
        width: '100%',
        marginLeft: '1.5%', 
        border: '2px solid #F5E414'
      },

      ['@media (max-width:540px)']: { 
        width: '211px',
        marginLeft: '2.5%', 
        border: '2px solid #F5E414'
      },

      ['@media (max-width:320px)']: { 
        width: '286px',
        marginLeft: '2.5%', 
        border: '2px solid #F5E414'
      },
    }
   
  }); 

export const SelectStyles = styled(Select)`
  height: 45px !important;
  line-height: 20px !important;
  & > div{
    height: 23px !important;
    font-size: 16px !important;
    min-height: 20px !important;
    line-height: 20px !important;
  }
`;

export const StyledPopup = styled(Popup)`
  &-content {
      max-width: 610px;
      padding: 20px;
      @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        margin-bottom: 0px;
        margin-top: 20px !important;
        width: 80% !important;
      }
      & > div {
        width: 100%;
        border-radius: 0px !important;
        & div {
          width: 100%;
          border-radius: 0px;
        }
      }
      
    }
`;

export const HeadModal = styled.div`
    display: flex;
    justify-content: space-between;
`